import { MessageCircle, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

export default function FloatingCTA() {
  return (
    <div
      className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3"
      data-testid="floating-cta"
    >
      <a
        href={CONTACT.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="float-whatsapp"
        className="group flex items-center gap-3 border-2 border-[#101828] bg-[#25D366] px-4 py-3 font-semibold text-[#0B111A] shadow-[4px_4px_0_0_#101828] transition-transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_0_#101828]"
      >
        <MessageCircle className="h-5 w-5" strokeWidth={2.5} />
        <span className="hidden text-sm sm:inline">WhatsApp</span>
      </a>
      <a
        href={CONTACT.telHref}
        aria-label="Call our desk"
        data-testid="float-call"
        className="group flex items-center gap-3 border-2 border-[#101828] bg-[#D92D20] px-4 py-3 font-semibold text-white shadow-[4px_4px_0_0_#101828] transition-transform hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_0_#101828]"
      >
        <Phone className="h-5 w-5" strokeWidth={2.5} />
        <span className="hidden text-sm sm:inline">Call desk</span>
      </a>
    </div>
  );
}
